import { IS_NATIVE_APP } from '../config/environment'

type Listener = (active: boolean) => void
const listeners = new Set<Listener>()
let configured = false

export function onAppForegroundChange(listener: Listener): () => void {
	listeners.add(listener)
	if (!configured) {
		configured = true
		const publish = (active: boolean) =>
			listeners.forEach((callback) => callback(active))
		document.addEventListener('visibilitychange', () =>
			publish(document.visibilityState !== 'hidden'),
		)
		window.addEventListener('pageshow', () => publish(true))
		window.addEventListener('focus', () =>
			publish(document.visibilityState !== 'hidden'),
		)
		if (IS_NATIVE_APP) {
			void import('@capacitor/app')
				.then(({ App }) =>
					App.addListener('appStateChange', (state) =>
						publish(state.isActive),
					),
				)
				.catch((error) =>
					console.error(
						'Could not subscribe to native app state',
						error,
					),
				)
		}
	}
	return () => {
		listeners.delete(listener)
	}
}
